/**
 * Given an array of faces, retrieve the largest face if possible
 *
 * @param {Array} faces the photo faces
 * @returns {Object|null}
 */
export const getLargestFace = faces => {
  if (!faces?.length) {
    return null;
  }

  if (faces.length === 1) {
    return faces[0];
  }

  const sortedFaces = [...faces].sort((a, b) => {
    // Faces are composed of x, y, w, h
    const aBox = a.facebox[2] * a.facebox[3];
    const bBox = b.facebox[2] * b.facebox[3];

    if (aBox > bBox) {
      return -1;
    }

    if (aBox < bBox) {
      return 1;
    }

    return 0;
  });

  const [largestFace, secondFace] = sortedFaces;

  const largestFaceBox = largestFace.facebox[2] * largestFace.facebox[3];
  const secondFaceBox = secondFace.facebox[2] * secondFace.facebox[3];

  // In the case of there being multiple faces, we will only allow to automatically tag
  // if the largest face box is at the very least 25% larger than the second largest face.
  if (largestFaceBox * 0.5 < secondFaceBox) {
    return null;
  }

  return largestFace;
};
